import httpClient from "@/services/base.service.js";

let apiBase = '/api/v1/bidinvitationstatustype';

export default {
  getAll: function () {
    return httpClient.get(`${apiBase}/get`);
  }
};
